import styled from "styled-components";

import { Survey } from "./Survey";

import { media, Spacing, Text } from "@otta/design";
import { pxToRem, palette } from "@otta/design-tokens";
import { Company } from "@otta/search/schema";

const Container = styled.div`
  ${media({ from: "tablet" })`
    border-left: ${pxToRem(1)} solid ${palette.brand.grey};
    padding: 0 ${pxToRem(20)} 0 ${pxToRem(40)};
  `}
`;

interface ISurveyListProps {
  company: Company.Company;
}

export function SurveyList({ company }: ISurveyListProps): React.ReactElement {
  return (
    <Container>
      <Text bold size={1}>
        What makes {company.name} a great place to work?
      </Text>
      <Spacing size={-1}>
        {company.employeeSurveys.map((survey, index) => (
          <Survey
            survey={survey}
            key={survey.id}
            isLast={index === company.employeeSurveys.length - 1}
          />
        ))}
      </Spacing>
    </Container>
  );
}
